import * as yup from 'yup';
import { AbsenceType, CarePeriodCareType, values } from '../../../enums';

export const CareLevelSchema = yup.object({
  level: yup.string().required().matches(/[0-5]/),
  date: yup.date().required(),
  provisional: yup.boolean().required(),
});

export const CarePeriodSchema = yup.object({
  type: yup.mixed<CarePeriodCareType>().oneOf(values(CarePeriodCareType)).required(),
  startDate: yup.date().required(),
  endDate: yup.date().notRequired().nullable(),
});

export const AbsenceSchema = yup.object({
  type: yup.mixed<AbsenceType>().oneOf(values(AbsenceType)).required(),
  startDate: yup.date().required(),
  endDate: yup.date().notRequired().nullable(),
  comment: yup.string().notRequired().nullable(),
});

export const ResidentContractSchema = yup.object({
  moveInDate: yup.date().notRequired().nullable(),
  notCalculateMoveInDate: yup.boolean().notRequired().nullable(),
  moveOutDate: yup.date().notRequired().nullable(),
  notCalculateMoveOutDate: yup.boolean().notRequired().nullable(),
  moveOutReason: yup.string().notRequired().nullable(),
  billAccommodationAndLodgingPrivatelyInMoveOutMonth: yup.boolean().notRequired().nullable(),
  prescriptionFeeUntil: yup.date().notRequired().nullable(),
  prescriptionFeeNote: yup.boolean().notRequired().nullable(),
  prescriptionFeeWeeksBeforeExpiry: yup.mixed().when('prescriptionFeeNote', {
    is: true,
    then: yup.number().required(),
  }),
  prescriptionFeeNoteText: yup.string().notRequired().nullable(),
  careLevels: yup.array<ICareLevel>().of(CareLevelSchema).default([]),
  lastApplicationDate: yup.date().notRequired().nullable(),
  lastMdkDate: yup.date().notRequired().nullable(),
  carePeriods: yup.array<ICarePeriod>().of(CarePeriodSchema).default([]),
  absences: yup.array<IAbsence>().of(AbsenceSchema).default([]),
  performanceSurcharge: yup.boolean().nullable(),
  nextLevelStartDate: yup.date().notRequired().nullable(),
  suppressPflegegradHint: yup.boolean().notRequired().nullable(),
});

export const CreateResidentContractSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(ResidentContractSchema);

export const UpdateResidentContractSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(ResidentContractSchema);

export interface ICareLevel {
  level: string;
  date: Date;
  provisional: boolean;
}

export interface ICarePeriod {
  type: CarePeriodCareType;
  startDate: Date;
  endDate?: Date;
}

export interface IAbsence {
  type: AbsenceType;
  startDate: Date;
  endDate?: Date;
  comment?: string;
}

export interface IResidentContract {
  isApplicant?: boolean;
  moveInDate?: string;
  notCalculateMoveInDate: boolean;
  moveOutDate?: string;
  notCalculateMoveOutDate: boolean;
  moveOutReason?: string;
  billAccommodationAndLodgingPrivatelyInMoveOutMonth?: boolean;
  prescriptionFeeUntil?: Date;
  prescriptionFeeNote?: boolean;
  prescriptionFeeNoteText?: string | null;
  prescriptionFeeWeeksBeforeExpiry?: number | null;
  careLevels: ICareLevel[];
  lastApplicationDate?: Date;
  lastMdkDate?: Date;
  carePeriods: ICarePeriod[];
  absences: IAbsence[];
  performanceSurcharge: boolean;
  nextLevelStartDate?: Date;
  remark?: string;
  suppressPflegegradHint?: boolean;
}

export interface ICreateResidentContract extends IResidentContract {
  residentId: string;
}

export interface IUpdateResidentContract extends IResidentContract {
  id: string;
}
